// src/data/services/jasa-instalasi-jaringan-cctv.tsx

"use client";
import { ServiceSection } from "@/components/ServiceSection";
import { site } from "@/data/default";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css/pagination";
import "swiper/css";

const JasaInstalasiJaringanCCTVContent = (
  <>
    {/* DESKRIPSI */}
    <ServiceSection id="deskripsi" title="Jasa Instalasi Jaringan & CCTV">
      <div className="grid md:grid-cols-2 gap-8 items-center">
        <div>
          <h1 className="text-3xl md:text-4xl font-bold leading-tight mb-4">
            Sinyal CCTV Hilang = Duit Hilang.
            <span className="text-purple block mt-2">
              Tenangkan Dirimu. Kita Pasangin Semua, Rapi, Legal, Tuntas.
            </span>
          </h1>
          <p className="text-base mb-4">
            Pernah ngalamin ini?
            <br />📉 Meeting ngelag, CCTV nge-freeze pas maling lewat, kabel berantakan kayak benang kusut.
            <br />
            Di sinilah kerennya kita. Bukan cuma teknisi, kita solusi. Kita bantu kamu tidur nyenyak sambil semuanya tetap nyala, tanpa harus ngerti IP address atau router.
          </p>
          <ul className="text-sm space-y-2 mb-6 text-muted-foreground">
            <li>✅ Survey lokasi GRATIS + Rekomendasi alat</li>
            <li>✅ CCTV bisa diakses dari HP, dari Bali sampai Belanda</li>
            <li>✅ Dokumentasi jalur & pengaturan, kamu pegang kendali penuh</li>
            <li>✅ Area layanan: Jakarta, Bekasi, Depok, Tangerang, Bogor</li>
          </ul>
          <a
            href={`https://wa.me/${site.whatsapp}?text=Hai%2C%20tolong%20cek%20lokasi%20saya%20buat%20CCTV%20atau%20jaringan`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-purple-600 to-orange-600 text-white px-6 py-3 rounded-full font-semibold hover:scale-105 transition"
          >
            ⚡ Sharelok, Kita Breakdown Sekarang!
          </a>
        </div>
        <div className="hidden md:block rounded-xl overflow-hidden">
          <img
            src="/images/services/instalasi-jaringan.webp"
            alt="Instalasi Jaringan & CCTV"
            className="w-full max-w-md mx-auto"
            width={1024}
            height={1024}
          />
        </div>
      </div>
    </ServiceSection>

    {/* EDUKASI */}
    <ServiceSection id="edukasi" title="Kenapa Jaringan & CCTV Harus Dikerjakan Profesional?">
      <div className="space-y-4 text-sm">
        <p>
          CCTV yang cuma nyala = <strong>bohongin diri sendiri.</strong>
          <br />
          Jaringan yang tiap minggu error = <strong>pemborosan yang kamu anggap normal.</strong>
        </p>
        <p>
          Tapi kamu sadar... ini semua bisa diselesaikan dalam <strong>1 hari kerja</strong> kalau teknisinya ngerti flow bisnis, bukan cuma nyolder kabel.
        </p>
        <ul className="list-disc ml-6">
          <li><strong>Topologi jaringan</strong> biar IP nggak bentrok & internet tetap stabil</li>
          <li><strong>Penempatan kamera</strong> itu ilmu, bukan asal tempel di pojokan</li>
          <li><strong>Remote access</strong> biar bisa cek CCTV dari HP kapanpun</li>
          <li><strong>Setting bandwidth</strong> biar WiFi dan CCTV nggak rebutan</li>
        </ul>
        <p>
          Kita jelasin semua ini ke kamu, pakai bahasa awam. Setelah teknisi pulang, kamu tetap ngerti sistemmu sendiri.
        </p>
      </div>
    </ServiceSection>

    {/* KEUNGGULAN */}
    <ServiceSection id="keunggulan" title="Apa Bedanya Kami dengan Tukang Lepas?">
      <div className="grid md:grid-cols-2 gap-6 mt-10">
        {[{
          title: "🔍 Kita Nggak Asal Pasang",
          desc: "Kita rancang sistem. Mulai dari kabel, aliran data, hingga alur akses, semua pakai logika, bukan kebiasaan pasar."
        },
        {
          title: "📱 Semua Bisa Dicek Dari HP",
          desc: "Termasuk notifikasi gerak, live monitor, bahkan backup otomatis, kita aktifin semua fitur penting. Tanpa biaya langganan tambahan."
        },
        {
          title: "🛠️ Dokumentasi Lengkap",
          desc: "Kamu dikasih skema kabel, login router, & panduan troubleshooting. Biar kamu nggak panik kalau teknisi udah balik."
        },
        {
          title: "🚨 Bukan Vendor, Tapi Partner",
          desc: "Kami bukan cari proyek, tapi bantu kamu jadi lebih tenang, lebih siap, lebih aman. Instalasi hari ini, peace of mind bertahun-tahun."
        }].map((item, i) => (
          <div
            key={i}
            className="group flex flex-col justify-between p-6 border rounded-xl shadow-md bg-gradient-to-br from-white to-gray-50 hover:from-purple-50 hover:to-white transition-all duration-300 hover:shadow-xl"
          >
            <div className="flex items-start gap-4">
              <div className="text-4xl">{item.title.split(" ")[0]}</div>
              <div>
                <h3 className="text-lg font-semibold mb-1">
                  {item.title.split(" ").slice(1).join(" ")}
                </h3>
                <p className="text-sm leading-relaxed">{item.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </ServiceSection>

    {/* LAYANAN */}
    <ServiceSection id="layanan" title="Layanan Kami">
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
        {[
          {
            title: "Instalasi Jaringan LAN",
            desc: "Penarikan kabel UTP untuk jaringan kantor, rumah, sekolah, hingga pabrik. Dikerjakan rapi, terstruktur, dan bergaransi.",
            tags: ["Switch", "Patch Panel", "RJ45"]
          },
          {
            title: "Instalasi WiFi Area Luas",
            desc: "Jangkauan sinyal optimal untuk rumah besar, kantor bertingkat, atau gudang. Termasuk setting repeater & bandwidth management.",
            tags: ["Access Point", "Router", "Omada"]
          },
          {
            title: "Pasang CCTV IP & Analog",
            desc: "Mulai dari 2 hingga 32 titik. Bisa kombinasi indoor/outdoor. Kami bantu perencanaan titik kamera & blindspot protection.",
            tags: ["Hikvision", "Dahua", "NVR"]
          },
          {
            title: "Rental Perangkat Jaringan",
            desc: "Sewa harian/mingguan untuk project, event, atau backup sementara. Perangkat siap pakai tanpa ribet setup."
            , tags: ["Router", "CCTV", "Server"]
          },
          {
            title: "Setting Router & Server CCTV",
            desc: "Konfigurasi port, IP statis, hingga remote via internet. Cocok untuk pemilik banyak cabang atau gudang."
            , tags: ["Dynamic DNS", "Port Forwarding", "Remote View"]
          },
          {
            title: "Maintenance & Troubleshooting",
            desc: "Kabel putus, kamera mati, sinyal lemah? Kami siap panggilan cepat tanpa harus pasang baru.",
            tags: ["Service", "Replace", "Upgrade"]
          }
        ].map((item, i) => (
          <article
            key={i}
            className="relative group p-6 bg-gradient-to-br from-white to-gray-50 border border-gray-200 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 ease-in-out h-full flex flex-col justify-between"
            itemScope
            itemType="https://schema.org/Service"
          >
            <div>
              <h3 itemProp="name" className="text-xl font-bold group-hover:text-purple-600 transition-colors">
                {item.title}
              </h3>
              <div className="flex flex-wrap gap-2 mt-3 mb-4">
                {item.tags.map((tag, t) => (
                  <span
                    key={t}
                    className="text-xs font-medium bg-purple-100 text-purple-800 px-2 py-1 rounded-md"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <p itemProp="description" className="text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          </article>
        ))}
      </div>
    </ServiceSection>

    {/* STUDI KASUS */}
    <ServiceSection id="studi-kasus" title="Studi Kasus Proyek Nyata">
      <div className="grid md:grid-cols-2 gap-4 mt-6">
        {[
          {
            title: "Instalasi CCTV + WiFi di Kantor Arsitektur (Bekasi)",
            client: "Kantor 3 lantai, Bekasi Timur",
            tags: ["6 IP Cam", "2 Access Point", "NAS Storage"],
            result: "Kini kantor bisa memantau aktivitas tim & tamu dari HP. Semua terekam ke NAS otomatis, tanpa biaya cloud bulanan."
          },
          {
            title: "Pasang CCTV Rumah Tinggal (Jakarta Selatan)",
            client: "Rumah pribadi 2 lantai",
            tags: ["4 Kamera Outdoor", "Paket Hemat", "Akses HP"],
            result: "Pemilik rumah bisa cek kondisi pagar, taman, dan garasi dari luar kota. Setup selesai dalam 1 hari kerja."
          },
          {
            title: "Rental NVR + Kamera IP untuk Event (Jakarta Barat)",
            client: "Acara peresmian gedung startup",
            tags: ["Rental Harian", "Instalasi Sementara", "Live Monitor"],
            result: "Klien tidak perlu beli alat mahal. Cukup sewa dan kami handle semua. Bisa live monitor + backup otomatis."
          },
          {
            title: "Instalasi Jaringan Kantor Logistik (Bekasi)",
            client: "Gudang + Kantor Operasional",
            tags: ["24 Port Switch", "WiFi Indoor", "Topologi Star"],
            result: "Setiap ruangan kini terhubung internet stabil, CCTV terintegrasi, dan user bisa akses printer jaringan dengan mudah."
          }
        ].map((item, i) => (
          <div key={i} className="p-5 border border-gray-200 rounded-xl bg-white shadow-sm hover:shadow-md transition duration-200">
            <h3 className="text-lg font-semibold mb-1">{item.title}</h3>
            <p className="text-sm text-muted-foreground italic mb-2">{item.client}</p>
            <div className="flex flex-wrap gap-2 mb-3">
              {item.tags.map((tag, t) => (
                <span key={t} className="text-xs bg-gray-100 px-2 py-0.5 rounded-md font-medium">
                  {tag}
                </span>
              ))}
            </div>
            <p className="text-sm">{item.result}</p>
          </div>
        ))}
      </div>
    </ServiceSection>

    {/* HARGA */}
    <ServiceSection id="harga" title="Paket Harga Fleksibel & Transparan">
      <p className="text-sm mb-12">Kami percaya: setiap proyek itu unik. Makanya, paket harga kami bukan sekadar angka, tapi solusi nyata.<br />Mulai dari paket hemat untuk rumah pribadi, sampai skema besar untuk pabrik dan kantor pusat. Semua transparan, nggak ada biaya siluman.</p>
      <div className="grid md:grid-cols-3 gap-4 my-10">
        {/* PAKET HEMAT */}
        <div className="flex flex-col justify-between border border-gray-200 rounded-3xl p-6 shadow-sm hover:shadow-xl hover:scale-[1.02] transition-all duration-300 bg-white">
          <div>
            <h3 className="font-bold mb-2 flex items-center gap-2">💡 Paket Hemat</h3>
            <p className="text-3xl font-bold mb-4">Rp1,5 Juta~</p>
            <ul className="text-sm space-y-2 mb-4">
              <li>✅ 1-4 Titik Kamera atau 1 Area WiFi</li>
              <li>✅ Instalasi 1 Hari</li>
              <li>✅ Termasuk Setting Router/NVR</li>
              <li>✅ Estimasi 4-6 Jam</li>
            </ul>
          </div>
          <p className="text-xs italic text-muted-foreground mt-6">
            Cocok untuk rumah pribadi atau kantor kecil.
          </p>
        </div>

        {/* PAKET KANTOR */}
        <div className="flex flex-col justify-between relative border-2 border-purple-600 rounded-3xl p-6 bg-gradient-to-b from-purple-50 to-white shadow-lg hover:shadow-2xl transition-all duration-300 scale-[1.03] z-10">
          <div className="absolute -top-3 right-4 bg-purple-600 text-white text-xs px-3 py-1 rounded-full shadow">
            ⭐ Paling Populer
          </div>
          <div>
            <h3 className="font-bold mb-2 flex items-center gap-2 text-purple-700">🚀 Paket Kantor</h3>
            <p className="text-3xl font-bold text-purple-800 mb-4">Rp4 Juta~</p>
            <ul className="text-sm space-y-2 mb-4 ">
              <li>✅ 6-12 Titik Kamera / 2-3 Lantai Jaringan</li>
              <li>✅ Topologi Jaringan + CCTV</li>
              <li>✅ Konfigurasi & Remote Access</li>
              <li>✅ Estimasi 1-2 Hari</li>
            </ul>
          </div>
          <p className="text-xs italic text-muted-foreground mt-6">
            Ideal untuk kantor, sekolah, atau gudang skala menengah.
          </p>
        </div>

        {/* PAKET PROYEK */}
        <div className="flex flex-col justify-between border border-gray-200 rounded-3xl p-6 shadow-sm hover:shadow-xl hover:scale-[1.02] transition-all duration-300 bg-white">
          <div>
            <h3 className="font-bold mb-2 flex items-center gap-2">🏢 Paket Proyek</h3>
            <p className="text-3xl font-bold text-orange-600 mb-4">Rp10 Juta+</p>
            <ul className="text-sm space-y-2 mb-4">
              <li>✅ 16+ Titik Kamera atau Jaringan Komplek</li>
              <li>✅ Integrasi Perangkat + Sewa Opsional</li>
              <li>✅ Skema Kabel, Rack, Switch Terpusat</li>
              <li>✅ Estimasi 3-5 Hari</li>
            </ul>
          </div>
          <p className="text-xs italic text-muted-foreground mt-6">
            Untuk skala besar: kantor pusat, pabrik, atau apartemen.
          </p>
        </div>
      </div>

      {/* CTA */}
      <div className="text-center mt-10">
        <p className="text-sm mt-8">
          Pernah ditinggal teknisi pas kamera baru nyala separuh? Atau sinyal WiFi cuma kuat di ruang tamu? 😫<br />
          Kami bantu breakdown masalahmu satu-satu. Gratis konsultasi, tanpa komitmen.
        </p>
        <p className="text-sm mb-2">Butuh penyesuaian paket atau mau tanya dulu?</p>
        <a
          href={`https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20mau%20konsultasi%20instalasi%20jaringan%20atau%20CCTV`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-gradient-to-r from-indigo-600 via-purple-600 to-orange-500 text-white text-sm px-6 py-3 rounded-full shadow-lg hover:scale-105 transition"
        >
          🚀 Konsultasi Gratis Sekarang → Kami Bantu Breakdown!
        </a>
      </div>
    </ServiceSection>

    {/* FAQ */}
    <ServiceSection id="faq" title="FAQ - Pertanyaan Umum">
      <div className="space-y-4">
        {[
          {
            question: "Emang perlu profesional ya? Tukang komplek aja bisa, kok!",
            answer:
              "Tukang bisa pasang kabel. Kami bisa mencegah kamu rugi. Mau nyuruh orang ngubur kabel tanpa grounding & lightning protector? Siap-siap NVR gosong kena petir."
          },
          {
            question: "Berapa biaya pasang CCTV & jaringan di rumah?",
            answer:
              "Mulai dari Rp1,5 juta untuk instalasi sederhana (1-4 titik). Biaya bisa disesuaikan tergantung jumlah titik, panjang kabel, dan jenis perangkat. Konsultasi awal gratis."
          },
          {
            question: "Apakah bisa sewa perangkat saja tanpa teknisi?",
            answer:
              "Bisa. Kami menyediakan paket rental kamera, NVR, hingga router untuk kebutuhan event, proyek, atau backup jaringan sementara. Pengiriman & pickup tersedia."
          },
          {
            question: "Apa saja yang termasuk garansi?",
            answer:
              "Garansi mencakup kualitas instalasi & fungsi perangkat selama 3 bulan. Termasuk: kamera mati, IP conflict, atau koneksi putus. Tidak termasuk force majeure atau salah penggunaan."
          },
          {
            question: "Apakah bisa remote CCTV dari HP?",
            answer:
              "Tentu. Semua setup CCTV kami bisa diakses via aplikasi HP, baik Android maupun iOS. Termasuk fitur notifikasi gerak & rekaman jarak jauh."
          },
          {
            question: "Apakah bisa pasang malam/minggu?",
            answer:
              "Bisa. Jadwal fleksibel sesuai kebutuhan proyek kamu. Untuk weekend atau malam hari, pastikan booking minimal H-1 ya."
          }
        ].map((item, i) => (
          <details
            key={i}
            className="group border border-gray-200 rounded-xl p-4 transition-all open:shadow-sm open:bg-gray-50"
          >
            <summary className="font-semibold text-base cursor-pointer list-none flex justify-between items-center">
              <span>{item.question}</span>
              <span className="ml-2 transform group-open:rotate-180 transition-transform">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                  <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                </svg>
              </span>
            </summary>
            <p className="mt-3 text-sm">{item.answer}</p>
          </details>
        ))}
      </div>
    </ServiceSection>

    {/* CLIENT LOGO */}
    <ServiceSection id="client-logo" title="Dipercaya oleh Klien dari Berbagai Industri">
      <div className="mt-6">
        <Swiper
          spaceBetween={20}
          slidesPerView={2}
          breakpoints={{
            640: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            1024: { slidesPerView: 5 },
          }}
          loop
          autoplay={{ delay: 3000 }}
          className="opacity-80 grayscale hover:grayscale-0 transition-all"
        >
          {[
            "/images/clients/client-1.png",
            "/images/clients/client-2.png",
            "/images/clients/client-3.png",
            "/images/clients/client-4.png",
            "/images/clients/client-5.png",
            "/images/clients/client-6.png",
            "/images/clients/client-7.png",
            "/images/clients/client-8.png",
          ].map((logo, index) => (
            <SwiperSlide key={index}>
              <div className="flex justify-center items-center h-20">
                <img
                  src={logo}
                  alt={`Logo Klien Software Development ${index + 1}`}
                  className="max-h-12 object-contain"
                  loading="lazy"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </ServiceSection>

    {/* TESTIMONI */}
    <ServiceSection id="testimoni" title="Apa Kata Klien Kami?">
      <div className="">
        <Swiper
          spaceBetween={20}
          slidesPerView={1.2}
          breakpoints={{
            768: { slidesPerView: 2.2 },
            1024: { slidesPerView: 3 },
          }}
          autoplay={{ delay: 6000 }}
          loop
        >
          {[
            {
              name: "Dwi Handayani",
              job: "Pemilik Rumah di Bekasi",
              comment:
                "Teknisi datang tepat waktu, rapi banget kerjanya. Sekarang saya bisa pantau rumah dari HP meski lagi kerja di luar kota. Sangat direkomendasikan!",
              image: "/images/testimonials/testimony-dwi.webp",
            },
            {
              name: "Yusuf Maulana",
              job: "Manajer Gudang Jakarta Timur",
              comment:
                "Tim ini bantu kami pasang jaringan & CCTV dalam 3 hari. Hasilnya rapi, sinyal stabil, dan semua kamera bisa dicek remote. Pekerjaan profesional!",
              image: "/images/testimonials/testimony-yusuf.webp",
            },
            {
              name: "Rina Kartikasari",
              job: "Event Organizer Jakarta",
              comment:
                "Kami sewa perangkat CCTV untuk event besar, dan semuanya ready tanpa drama. Tim juga standby selama acara. Next event pasti repeat lagi!",
              image: "/images/testimonials/testimony-rina.webp",
            },
            {
              name: "Hendro Saputra",
              job: "Owner Ruko di Bekasi",
              comment:
                "Gue pasang 8 kamera, dapet PDF jalur kabel, login router, & semua CCTV bisa dicek dari HP gue... Gila sih, detailnya lebih rapih dari kerjaan kantor gue.",
              image: "/images/testimonials/testimony-hendro.webp",
            },
          ].map((item, i) => (
            <SwiperSlide key={i} className="h-full flex self-stretch mb-4">
              <div className="bg-white border rounded-xl shadow-sm p-5 flex flex-col justify-between hover:shadow-md transition-all">
                <p className="text-sm leading-relaxed italic mb-4">"{item.comment}"</p>
                <div className="flex items-center gap-3">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-semibold">{item.name}</p>
                    <p className="text-xs text-muted-foreground">{item.job}</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </ServiceSection>

    {/* KONTAK */}
    <ServiceSection id="kontak" title="Diskusi Proyek atau Booking Teknisi">
      <div className="grid md:grid-cols-2 gap-4 items-center mt-6">
        <div>
          <h3 className="text-2xl font-bold mb-4">
            Butuh instalasi atau perbaikan jaringan/CCTV?
          </h3>
          <p className="text-base mb-4">
            Kami bukan vendor. Kami penenang pikiran. Setiap sistem yang kami pasang = pertahanan digital & fisik bisnismu.
          </p>
          <ul className="text-sm space-y-1 mb-6 text-muted-foreground">
            <li>✅ Konsultasi teknis langsung via WhatsApp</li>
            <li>✅ Estimasi waktu & harga dalam 1x24 jam</li>
            <li>✅ Bisa langsung booking teknisi hari itu juga*</li>
          </ul>
          <a
            href={`https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20butuh%20bantuan%20untuk%20instalasi%20jaringan%20atau%20CCTV`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-green text-white px-6 py-3 rounded-xl font-semibold hover:bg-green/90 transition"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="text-white me-2" viewBox="0 0 16 16">
              <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
            </svg>
            🎯 Konsultasi Sekarang → Biar Kami Breakdown Sistemnya
          </a>
          <p className="text-xs mt-3 ">Aktif setiap hari, 08.00 - 21.00 WIB</p>
        </div>

        <div className="relative w-full h-64 md:h-full rounded-xl overflow-hidden">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.8420521856533!2d106.99524857499078!3d-6.284483493704425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e698d6d29d17095%3A0x765e1cdf4db9b9bb!2sGratia%20Global%20Solution!5e0!3m2!1sid!2sid!4v1754466163988!5m2!1sid!2sid"
            width="100%"
            height="100%"
            allowFullScreen
            loading="lazy"
            className="border-0 w-full h-full"
            title="Lokasi Kantor"
          ></iframe>
          <div className="absolute bottom-4 left-4 bg-white/90 text-sm px-4 py-2 rounded shadow">
            📍 Berbasis di Bekasi - Melayani Jakarta & Sekitarnya
          </div>
        </div>
      </div>
    </ServiceSection>
  </>
);

export default JasaInstalasiJaringanCCTVContent;